<template>
  <Teleport to="body">
    <Transition name="qc-balloon-fade">
      <div v-if="isVisible" class="qc-balloon-tips" :class="[typeClass, className]">
        <div class="qc-balloon-content">
          <span class="qc-balloon-message">{{ message }}</span>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
import { ref, computed, onUnmounted } from 'vue';

interface Props {
  message?: string;
  type?: 'success' | 'error' | 'warning' | 'info';
  duration?: number;
  className?: string;
}

const props = withDefaults(defineProps<Props>(), {
  message: '',
  type: 'info',
  duration: 2000,
  className: ''
});

// 声明组件可以触发的事件
const emit = defineEmits<{
  destroy: []
}>();

const isVisible = ref(false);

/**
 * 根据类型计算样式类名
 */
const typeClass = computed(() => {
  return `qc-balloon-${props.type}`;
});

/**
 * 显示气泡提示
 */
const show = () => {
  isVisible.value = true;
  if (props.duration > 0) {
    setTimeout(() => {
      hide();
    }, props.duration);
  }
};

/**
 * 隐藏气泡提示
 */
const hide = () => {
  isVisible.value = false;
};

// 组件卸载时触发destroy事件
onUnmounted(() => {
  emit('destroy');
});

defineExpose({
  show,
  hide
});
</script>

<style lang="less" scoped>
.QCToastStyle() {
  .qc-balloon-tips {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%) scale(var(--qc-scale-ratio));
    z-index: 99999;
    border-radius: 8px;
    padding: 12px 20px;
    max-width: 560px;
    min-width: 120px;
    text-align: center;
    font-size: 28px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    backdrop-filter: blur(10px);
  }

  .qc-balloon-content {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }

  .qc-balloon-message {
    line-height: 1.4;
    word-break: break-word;
  }

  /* 类型样式 */
  .qc-balloon-success {
    background: rgba(82, 196, 26, 0.9);
    color: #fff;
  }

  .qc-balloon-error {
    background: rgba(255, 77, 79, 0.9);
    color: #fff;
  }

  .qc-balloon-warning {
    background: rgba(250, 173, 20, 0.9);
    color: #fff;
  }

  .qc-balloon-info {
    background: rgba(0, 0, 0, 0.8);
    color: #fff;
  }
}

.QCToastStyle();

@media (min-width: 750px) {
  .QCToastStyle();
}
</style>